<template>

<div class="review-wrap review-holder col-12">

    <div class="text-center" v-if='!isReady'>
        <img src='/resources/loader.svg' width="50px">
    </div>

    <div v-if='isReady && !ratings' class="alert alert-info">
        <div class="alert-icon">
            <span class="icon icon-poker-face"></span>
        </div>
        <div class="d-flex justify-content-between align-items-center w-100">
            <div>
                <span class="text-bold d-block">Sorry!</span>
                <span class="text-small">There are no reviews yet. You can write the first one!</span>
            </div>
        </div>
    </div>

    <div v-if="isReady && ratings" id="reviews-stats" class="review">
        <ul id="stats-tabs" class="nav nav-tabs models-tabs">
            <li class="nav-item">
                <a data-toggle="tab" href="#total-tab" role="tab" 
                   aria-controls="total-tab" aria-selected="true" 
                   class="nav-link active">Rating</a>
            </li>

            <li v-for='(n,i) in revMap' class="nav-item">
                <a data-toggle="tab" :href="'#tab-' + i" role="tab" 
                   :aria-controls="'#tab-' + i" aria-selected="false" 
                   class="nav-link">{{ n }}</a>
            </li>
        </ul>

        <div class="tab-content">
            <div id="total-tab" role="tabpanel" aria-labelledby="tatal-tab" class="tab-pane fade active show">
                <h4 class='mb-5 secondary-title'>
                    Overall stats from {{ ratings.reviews }} review{{ ratings.reviews > 1 ? 's' : '' }}
                </h4>
                <div class="rank-value-wrap pb-2 pr-3">

                    <div :class="['rank-value main-value', ratings.rating <=5 ? 'text-red' : 'text-green' ]">
                        <span v-if="ratings.rating <= 3" class="icon icon-sad mr-1"></span>
                        <span v-if="ratings.rating > 3 && ratings.rating <= 6" class="icon icon-poker-face mr-1"></span>
                        <span v-if="ratings.rating > 6"class="icon icon-smile1 mr-1"></span>
                        {{ ratings.rating }}
                        <span class="review-param">
                            Overall <br>
                            rating
                        </span>
                    </div>

                    <div class="rank-value">
                        {{ ratings.r1 }}
                        <span class="review-param">
                            Accuracy
                        </span>
                    </div>

                    <div class="rank-value">   
                        {{ ratings.r2 }}
                        <span class="review-param">
                            User <br>
                            Interface
                        </span>
                    </div>

                    <div class="rank-value">
                        {{ ratings.r3 }}
                        <span class="review-param">
                            Performance
                        </span>
                    </div>

                    <div class="rank-value">
                        {{ ratings.r4 }}
                        <span class="review-param">
                            Innovation
                        </span>
                    </div>
                </div>
            </div>

            <div v-for='(k,i) in revMap' :id="'tab-' + i" role="tabpanel" 
                 :aria-labelledby="'#tab-' + i" class="tab-pane fade">
                
                <div v-for="n in 10" :key="n" class="d-flex align-items-center flex-column flex-md-row mb-3">
                    
                    <div class="d-flex align-items-center progress-holder">
                        <span class="progress-num mr-3">{{11-n}}</span>
                        <div class="progress flex-grow-1">
                            <div class="progress-bar" role="progressbar" :style="{ width : getSP( i, 11-n ) }" 
                                 aria-valuenow="25%" aria-valuemin="0" aria-valuemax="100">
                                 {{ getSP( i, 11-n ) }}
                            </div>
                        </div>
                    </div>
                    <span class="progress-vote text-xs-small text-muted mt-1 mt-md-0 ml-md-3 font-weight-bold text-right text-md-left">
                        <span v-if='stats[i][11-n]'>
                            <span class="d-md-block"> {{ stats[i][11-n] }}</span> vote{{ stats[i][11-n] > 1 ? 's' : ''}}
                        </span>
                        <span v-else>
                             <span class="d-md-block"> 0 </span> votes
                        </span>
                    </span> 

                </div>

            </div>

        </div>
        
    </div>

</div>

</template>

<script>
    export default {

        mounted() {

            this.getData();

            bus.$on("refresh-stats", () => {
                this.getData();
            })
        },

        props : ['id'],

        created() {
           
        },

        data() { 

            return {
                isReady : false,

                revMap : {
                    // rating  : 'Rating',
                    r1   : 'Accuracy',
                    r2   : 'User Interface',
                    r3   : 'Performance',
                    r4   : 'Innovation',
                },

                stats : false,
                ratings : false
            }
            
        },

        methods : {

            getData() {
                this.ajax.call('rvw:sts', { id : this.id }, (r) => {
                    if( r.status == 'success' ) {

                        this.stats = r.data.c;
                        this.ratings = r.data.r;
                        this.isReady = true;

                    } else {

                    }
                })
            },

            getSP( i, n ) {
                if( typeof this.stats[i][n] == 'undefined' ) {
                    return "0%";
                }

                let num = this.stats[i][n];

                num = parseInt( (num / this.ratings.reviews) * 100 );

                return num + "%";
            }

        }

    }
</script>
